import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../api/api.service';
import { environment } from '../../../../environments/environment';

export interface Allergy {
    id: string;
    name: string;
    language: string;
}

export interface AllergyCategoryItem {
    id: string;
    name: string;
}

export interface AllergyCategory {
    categoryName: string;
    items: AllergyCategoryItem[];
}

interface ApiResponse<T> {
    data: T;
    status: number;
    fail: any;
    isSuccess: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AllergyService {
    private readonly baseUrl = `${environment.apiLocations.patient}/allergy`;

    constructor(private apiService: ApiService) { }

    getListAllergy(): Observable<AllergyCategory[]> {
        return this.apiService.get<ApiResponse<AllergyCategory[]>>(`${this.baseUrl}/getListAllergy`).pipe(
            map(response => (response.data || []) as AllergyCategory[])
        );
    }
}
